var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrendArrowUp(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "1em",
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.0625 6.53142L6.11482 2.4791L3.08515 2.55284C2.9265 2.5567 2.79478 2.43127 2.79092 2.27262C2.78706 2.11418 2.91239 1.98235 3.07113 1.97839L6.53123 1.8943C6.68469 1.8944 6.82902 1.95402 6.93759 2.06259C7.04606 2.17106 7.10578 2.31548 7.10568 2.47585L7.02158 5.92905C7.01976 6.00583 6.98797 6.07479 6.93759 6.12517C6.88396 6.17879 6.80921 6.21129 6.72735 6.20926C6.56871 6.2054 6.44338 6.07377 6.44724 5.91513L6.52747 2.87896L2.46875 6.93768C2.35663 7.04981 2.17462 7.04981 2.0625 6.93768C1.95037 6.82556 1.95037 6.64355 2.0625 6.53142Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrendArrowUp);
export default __webpack_public_path__ + "static/media/trend-arrow-up.56e5fdbd382957af598341b27f0f3a0e.svg";
export { ForwardRef as ReactComponent };